enum PCFS {
  PROCESSING = "PROCESSING",
  CANCELLED = "CANCELLED",
  FAILED = "FAILED",
  SUCCESS = "SUCCESS",
}

export default PCFS;
